export default __webpack_public_path__ + "static/media/transport.30704242.svg";